import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const AdminRoute = ({ children }) => {
	const role = useSelector((state) => state.org.orgRole)
	const userType = useSelector((state) => state.user.authUser?.userType)
	const allow = role === 'admin' || userType === 'superAdmin'

	if (allow === undefined) return null

	return allow === true ? children : <Navigate to='/' replace />
}

export default AdminRoute
